/* Open the native family directory before the theme's generic anchor handler. */
document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('a[href^="#cpis-all-families-"]');
  if (!link) return;
  // On mobile, the compact category rail is the intended destination.
  // The complete desktop directory is intentionally hidden on small screens.
  if (window.matchMedia && window.matchMedia('(max-width:640px)').matches) {
    const rail = document.querySelector('.cpis-home__mobile-directory');
    if (rail && window.getComputedStyle(rail).display !== 'none') {
      event.preventDefault();
      event.stopPropagation();
      rail.scrollIntoView({block:'start',behavior:'auto'});
      return;
    }
  }
  const target = document.getElementById(link.getAttribute('href').slice(1));
  const directory = target && target.closest('details');
  if (!directory) return;
  event.preventDefault();
  event.stopPropagation();
  directory.open = true;
  directory.scrollIntoView({block: 'start', behavior: 'auto'});
  directory.querySelector('summary').focus({preventScroll: true});
}, true);
